module.exports = __webpack_public_path__ + "static/media/barn-member.195c9c89.png";